<template>
  <div>
    <template class="page" v-if="!loading">
      <div class="page__title">
        {{ getModuleConfig("store_scan_page.form_title") || "請掃描或輸入店家代碼" }}
      </div>
      <div
        class="page__desc"
        v-html="getModuleConfig('store_scan_page.form_desc') || '請掃描店家 QR Code 或手動輸入店家代碼'"
      ></div>

      <div class="card pt-2 px-2">
        <div class="card__info">
          <div>
            <coupon-filters
              class="s-mb-3"
              :options="filterOptions"
              v-model="filter"
            ></coupon-filters>

            <div>
              <Loading v-if="showLoading" loading-message="載入中..." />
              <div v-else-if="!showLoading && filter == 'qrcode'" class="qrcode-panel">
                <QRCodeScanner @onScan="onScan" :qrbox="qrbox" />
              </div>
              <div v-else-if="!showLoading && filter == 'manual'">
                <input
                  class="search__input m-auto w-100"
                  v-model="barcode"
                  @input="barcodeFormatter"
                  placeholder="請輸入店家代碼"
                />
                <div class="mt-3">
                  <input
                    class="search__input m-auto w-100"
                    v-model="salesPerson"
                    maxlength="20"
                    placeholder="請輸入銷售人員(非必填)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div>
            <Loading v-if="showLoading" loading-message="載入中..." />
            <div v-else-if="!showLoading">
              <div
                v-html="getModuleConfig('store_scan_page.content')"
                class="p-4 rounded picker-content"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-3 fixed-bottom bg-white footer">
        <SharedButton
          class="s-btn-bg-primary mb-2"
          @click="confirmStore"
          :disabled="!barcode || showLoading"
        >
          {{ getModuleConfig("store_scan_page.button_text") || "確認店家" }}
        </SharedButton>

        <MemberButton
          :button-style="`s-btn-outline-primary`"
          :button-text="getModuleConfig('store_scan_page.cancel_button_text') || '取消'"
          :button-url="getModuleConfig('store_scan_page.cancel_button_url')"
          :type="getModuleConfig('store_scan_page.cancel_button_action') || 'back'"
          :disabled="showLoading"
        ></MemberButton>
      </div>
    </template>
    <template v-else>
      <div class="text-center p-4">
        <b-spinner variant="secondary" />
        <div class="mt-2">載入中...</div>
      </div>
    </template>
  </div>
</template>

<script>
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import Loading from "@/components/Page/Liff/Shared/Loading";
import SharedButton from "@/components/Page/Liff/Shared/Button";
import CouponFilters from "@/pages/Dashboard/Coupon/CouponFilters.vue";
import QRCodeScanner from "@/components/QRCodeScanner";
import couponMixin from "@/mixins/liff/coupon";
import { mapActions } from "vuex";

export default {
  mixins: [couponMixin],
  components: {
    Loading,
    SharedButton,
    CouponFilters,
    QRCodeScanner,
    MemberButton,
  },
  data() {
    return {
      qrbox: {
        width: 220,
        height: 220,
      },
      showLoading: false,
      loading: false,
      filter: "qrcode",
      barcode: null,
      salesPerson: null,
    };
  },

  computed: {
    filterOptions() {
      return [
        {
          key: "qrcode",
          text: "QR Code 掃描",
        },
        {
          key: "manual",
          text: "手動輸入",
        },
      ];
    },
  },

  mounted() {
    console.log("[AND CouponStoreScan] ========== CouponStoreScan.vue mounted() ==========");
    console.log("[AND CouponStoreScan] Route params:", this.$route.params);
    this.filter = "qrcode";
  },

  methods: {
    ...mapActions("projAbbottAnd", ["setStoreCode", "setVerifyCode", "setSalesInfo"]),

    onScan(decodedText) {
      console.log("[AND CouponStoreScan] QR scanned:", decodedText);
      this.barcode = decodedText;
      this.filter = "manual";
    },

    barcodeFormatter(event) {
      let value = event.target.value;
      this.barcode = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    },

    async confirmStore() {
      console.log("[AND CouponStoreScan] confirmStore() called");
      console.log("[AND CouponStoreScan] barcode (store_code):", this.barcode);

      if (!this.barcode) {
        alert("請輸入或掃描店家代碼");
        return;
      }

      try {
        this.showLoading = true;

        // 將店碼存入 Vuex (同時作為 store_code 和 verify_code)
        await this.setStoreCode(this.barcode);
        await this.setVerifyCode(this.barcode);

        const salesInfo = this.salesPerson ? this.salesPerson.trim() : "";
        await this.setSalesInfo(salesInfo || null);

        console.log("[AND CouponStoreScan] Store code saved, redirecting to CouponSelectItem");

        // 導向品項選擇頁面
        this.$router.push({
          name: "LiffProjAbbottAndCouponSelectItem",
        });

        this.showLoading = false;
      } catch (error) {
        console.error("[AND CouponStoreScan] Error:", error);
        this.showLoading = false;
        alert("發生錯誤，請重試");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  &__input {
    background: #ffffff;
    border-radius: 10px !important;
    border: 1px solid var(--liff-button-color);
    padding: 15px 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;

    &::placeholder {
      letter-spacing: -0.408px;
      color: #b7b7b7;
    }

    &:focus {
      border: 1px solid var(--liff-button-color);
      outline: none;
    }
  }
}

.qrcode-panel {
  max-width: 70%;
  margin: auto;
}

.page {
  padding-bottom: 140px !important;
}

.picker-content {
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
